__turbopack_context__.v({
  "customerCard": "CustomerCard-module__DKwsiW__customerCard",
});
